import { render, staticRenderFns } from "./FundsMoral.vue?vue&type=template&id=78be6731&"
import script from "./FundsMoral.vue?vue&type=script&lang=js&"
export * from "./FundsMoral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports